/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AxiosResponse } from 'axios';
import { QnaMakerOperationSwagger } from 'src/qnaMaker/core/types/qnaMakerOperationSwagger';

/**
 * Defines when to retry a long running polling operation
 * when using QnaMaker APIs.
 *
 * @param response The response received from the poll api.
 */
export const qnaMakerOperationRetryStrategy = <T extends QnaMakerOperationSwagger>(response: AxiosResponse<T>): boolean =>
    response.data.operationState !== 'Succeeded' && response.data.operationState !== 'Failed';

export const qnaMakerGenericFailureError = (jobId: string) => {
    const err = new Error(`QnA job with the jobId: ${jobId} failed`);
    err.name = 'QnA job failed';

    return err;
};
